<div>
  <div style="margin-bottom: 20px;">
    <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 4px 0;">Elige tu beneficiario</h2>
    <p style="font-size: 14px; color: #666; margin: 0;">Selecciona o agrega un beneficiario</p>
  </div>

  <!-- Search Bar -->
  <div style="position: relative; margin-bottom: 16px;">
    <input type="text" [(ngModel)]="searchTxt" (keyup)="buscar($event)" placeholder="Buscar beneficiario"
      style="width: 100%; padding: 14px 48px 14px 16px; border: 2px solid #e0e0e0; border-radius: 12px; font-size: 15px; outline: none; transition: border-color 0.2s; box-sizing: border-box;"
      onfocus="this.style.borderColor='#1C593D'" onblur="this.style.borderColor='#e0e0e0'" />
    <button type="button"
      style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #666; padding: 8px;">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="2" />
        <path d="M14 14L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <!-- Add Beneficiary Button -->
  <button type="button" (click)="openCreateDialog()"
    style="width: 100%; padding: 14px; border: 2px dashed #1C593D; background: white; color: #1C593D; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; margin-bottom: 24px; transition: all 0.2s;"
    onmouseover="this.style.background='#f0f9f5'" onmouseout="this.style.background='white'">
    Agregar beneficiario
  </button>

  <!-- Beneficiary List -->
  <div *ngIf="listaBeneficiariosFiltrados && listaBeneficiariosFiltrados.length > 0" style="margin-bottom: 24px;">
    <h3 style="font-size: 16px; font-weight: 700; color: #1a1a1a; margin: 0 0 16px 0;">Tus beneficiarios</h3>
    <div style="display: flex; flex-direction: column; gap: 12px;">
      <label *ngFor="let beneficiario of listaBeneficiariosFiltrados" (click)="elegir(beneficiario)"
        style="display: flex; align-items: center; gap: 12px; padding: 16px; border-radius: 12px; cursor: pointer; transition: all 0.2s;"
        [style.background]="beneficiarioEscogido === beneficiario ? '#f0f9f5' : 'white'"
        [style.border]="beneficiarioEscogido === beneficiario ? '2px solid #1C593D' : '2px solid #e0e0e0'">
        <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0;">
          <div style="width: 48px; height: 48px; border-radius: 50%; background: linear-gradient(135deg, #1C593D, #4caf50); display: flex; align-items: center; justify-content: center; color: white; font-size: 20px; font-weight: 700; flex-shrink: 0;">
            {{ beneficiario.nombre.charAt(0) }}
          </div>
          <div style="display: flex; flex-direction: column; gap: 4px; min-width: 0;">
            <span style="font-size: 15px; font-weight: 600; color: #1a1a1a; overflow: hidden; text-overflow: ellipsis;">
              {{ beneficiario?.nombre }} {{ beneficiario?.apellidos }}
            </span>
            <span style="font-size: 13px; color: #666; display: flex; align-items: center; gap: 4px;">
              {{ beneficiario?.banco?.nombre | titlecase }} &middot; {{ beneficiario?.banco?.codigoPais }}
            </span>
            <span style="font-size: 12px; color: #9ca3af;">
              {{ beneficiario?.movilPay==1 ? 'Movil Pay' : beneficiario?.tipoCuenta?.nombre }} &middot;
              <span *ngIf="beneficiario.movilPay==0">Cuenta: </span>
              <span *ngIf="beneficiario.movilPay==1">Tel: </span>
              {{ beneficiario?.numeroCuenta }}
            </span>
          </div>
        </div>
        <!-- Radio check -->
        <div style="width: 24px; height: 24px; border-radius: 50%; position: relative; flex-shrink: 0; transition: all 0.2s;"
          [style.border]="beneficiarioEscogido === beneficiario ? '2px solid #1C593D' : '2px solid #d0d0d0'"
          [style.background]="beneficiarioEscogido === beneficiario ? '#1C593D' : 'transparent'">
          <div *ngIf="beneficiarioEscogido === beneficiario"
            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 8px; height: 8px; background: white; border-radius: 50%;"></div>
        </div>
      </label>
    </div>
  </div>

  <!-- Continue Button -->
  <button type="button" (click)="emitChangeStep()"
    [disabled]="beneficiarioEscogido == undefined"
    [style.background]="beneficiarioEscogido ? '#1C593D' : '#d0d0d0'"
    [style.cursor]="beneficiarioEscogido ? 'pointer' : 'not-allowed'"
    [style.opacity]="beneficiarioEscogido ? '1' : '0.6'"
    style="width: 100%; padding: 16px; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; transition: background 0.2s, transform 0.1s;">
    Continuar
  </button>
</div>
